export { default as ErrorBoundary } from './src/error-boundary';
